module.exports = __webpack_public_path__ + "static/media/assets_loading.f99a8998.gif";